import Items from '#src/client/common/layout/Items.jsx';
import Button from '#src/client/common/interactive/Button.jsx';
import ErrorText from '#src/client/common/errors/ErrorText.jsx';

/**
 * @typedef SubmitAreaProps
 * @type {object}
 * @property {boolean} [isReadOnly] - true if the session is not active
 * @property {string} [errorAll] - the state.e.all error generated by the page's validator
 * @property {function} onSubmit - called when the submit button is pressed
 * @property {string} [submitText] - text on the submit button (default: "Submit")
 * @property {function} [onCancel] - function called when the cancel button is pressed; cancel button not shown if empty
 * @property {string} [cancelText] - text on the cancel button (default: "Cancel")
 * @property {boolean} [isCentered] - centers the buttons, messages, and warnings on the page
 */

/**
 * @param {SubmitAreaProps} props
 */
export default function SubmitArea(props) {
    const genExtra = () => {
        return [
            'alignCenter',
            props.isCentered ? 'justifyCenter' : null,
        ].filter(Boolean);
    };

    return (
        <fieldset disabled={props.isReadOnly}>
            <Items type="wrap" extra={genExtra()}>
                <Button
                    disabled={props.errorAll}
                    onClick={props.onSubmit}
                    data-hook-type="submitButton">{props.submitText ?? 'Submit'}</Button>
                <Show when={props.onCancel}>
                    <Button
                        onClick={props.onCancel}
                        color="subdued"
                        data-hook-type="cancelButton">{props.cancelText ?? 'Cancel'}</Button>
                </Show>
                <Show when={Object.prototype.toString.call(props.errorAll) === '[object String]'}>
                    <ErrorText error={props.errorAll} />
                </Show>
            </Items>
        </fieldset>
    );
}
